<template>
    <div class="w-100 p-3 my-1" :class="{ widget: viewWidget }">
        <div v-if="!viewWidget" class="w-100 d-flex justify-content-end">
            <p @click="openWidget()" class="text-primary cursor-pointer mb-0">
                <em>Parent activities & Therapist implementation instructions</em>
                <i class="fa fa-times-circle-o mx-1 text-primary rot-45"></i>
            </p>
        </div>
        <div class="w-100" v-else="">
            <div class="d-flex justify-content-between align-items-center w-100">
                <p class="text-uppercase font-weight-bold py-1 mb-0">Parent activities</p>
            </div>
            <hr class="bar" />
            <div class="d-flex justify-content-between mt-2">
                <textarea
                    v-if="updateWidget"
                    :disabled="!canEdit"
                    v-model="payload.parent_homework"
                    class="form-control"
                    name="homework"
                    id="homework"
                    rows="1"
                    placeholder="Write the parent's homework"
                ></textarea>
                <p class="font-italic" v-else="">{{ goal.parent_homework || `No data.` }}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center w-100 mt-2">
                <p class="text-uppercase font-weight-bold py-1 mb-0">
                    Therapist implementation instructions
                </p>
            </div>
            <hr class="bar" />
            <div class="d-flex justify-content-between mt-2">
                <textarea
                    v-if="updateWidget"
                    :disabled="!canEdit"
                    v-model="payload.therapist_instructions"
                    class="form-control"
                    name="homework"
                    id="instructions"
                    rows="1"
                    placeholder="Write the parent's homework"
                ></textarea>
                <p class="font-italic" v-else="">{{ goal.therapist_instructions || `No data.` }}</p>
            </div>
            <div class="d-flex w-100 justify-content-end mt-3">
                <button class="btn btn-sm btn-light mx-1" @click="closeWidget()">Close</button>
                <template v-if="canEdit">
                    <template v-if="updateWidget">
                        <button class="btn btn-sm btn-light mx-1" @click="cancelEditWidget()">
                            Cancel
                        </button>
                        <button class="btn btn-sm btn-primary mx-1" @click="saveWidget()">
                            Save
                        </button>
                    </template>
                    <button v-else="" class="btn btn-sm btn-primary mx-1" @click="editWidget()">
                        Edit
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsInstructions",
    props: ["goal", "canEdit"],
    data() {
        return {
            viewWidget: false,
            updateWidget: false,
            payload: {
                parent_homework: null,
                therapist_instructions: null,
            },
        };
    },

    created() {
        this.initialize();
    },

    watch: {
        goal() {
            this.initialize();
        },
    },

    methods: {
        initialize() {
            this.payload.parent_homework = this.goal.parent_homework;
            this.payload.therapist_instructions = this.goal.therapist_instructions;
            if (this.goal.parent_homework || this.goal.therapist_instructions) {
                this.viewWidget = true;
            }
        },

        openWidget() {
            this.viewWidget = true;
        },

        closeWidget() {
            this.viewWidget = false;
            this.updateWidget = false;
            this.payload = {
                parent_homework: null,
                therapist_instructions: null,
            };
        },

        cancelEditWidget() {
            this.updateWidget = false;
            this.payload = {
                parent_homework: null,
                therapist_instructions: null,
            };
        },

        editWidget() {
            this.initialize();
            this.updateWidget = true;
        },

        saveWidget() {
            const payload = { ...this.payload };
            axios
                .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, payload)
                .then(r => {
                    this.$emit("goal-updated");
                    this.cancelEditWidget();
                });
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
